import React, { useState, useEffect, useRef, useReducer } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo-kemenag.png";
import "./styles.css";

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

const initialState = {
	page: 1,
	query: "",
	filter: [],
	items: [],
	sort: "nama",
	sort_order: 1,
};

function reducer(state, action) {
	switch (action.type) {
		case "sort":
			return {
				...state,
				sort: action.sort,
				sort_order: action.sort_order,
				page: 1,
			};
		case "query":
			return { ...state, query: action.payload, page: 1 };
		case "filter":
			return { ...state, filter: action.payload, page: 1 };
		case "more":
			return { ...state, page: state.page + 1 };
		case "clear":
			return { ...state, page: 1, items: [] };
		default:
			throw new Error();
	}
}

const SearchBox = (props) => {
	const [value, setValue] = useState("");
	const timerRef = useRef();
	const lastValueRef = useRef("");

	useEffect(() => {
		if (lastValueRef.current == value) return;

		const id = setTimeout(() => {
			lastValueRef.current = value;
			props.onChange(value);
		}, 500);
		timerRef.current = id;
		return () => {
			clearTimeout(timerRef.current);
		};
	}, [value]);
	return (
		<input
			type="search"
			label="Cari"
			placeholder="Cari..."
			variant="filled"
			{...props}
			value={value}
			onChange={(e) => {
				setValue(e.target.value);
			}}
			style={{
				borderRadius: 5,
				border: "1px solid green",
				padding: "8px",
				width: 300,
				outline: "none",
			}}
		></input>
	);
	// return <input type="search" value={value} onChange={(e) => { setValue(e.target.value) }} placeholder="Cari Siswa" style={{ borderRadius: 5, border: 1, padding: "8px", fontSize: "11pt", "flexGrow": 1 }} />
};

export default function Admin(props) {
	const controller = useRef();
	// let history = useHistory();
	const [search, setSearch] = useState();
	const [page, setPage] = useState(1);
	const [items, setItems] = useState([]);
	const [more, setMore] = useState(false);
	const [loading, setLoading] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		...initialState,
		filter: props.filter,
		...props.sort,
	});

	const tableRef = useRef();

	function doSort(col) {
		let sort_order = state.sort_order;

		let sort = col;
		if (state.sort == col) {
			console.log(state.sort_order, !sort_order);

			sort_order = +!sort_order;
		}

		dispatch({ type: "sort", sort, sort_order });
	}
	async function load() {
		setLoading(true);
		setMore(true);

		let params = {
			s: "jateng",
			page: state.page,
			query: state.query,
			...state.filter,
			sort: state.sort,
			sort_order: state.sort_order,
		};

		let sp = new URLSearchParams();

		Object.entries(params).forEach((item) => {
			// note .set replaces while .append will duplicate params
			sp.set(...item);
		});

		if (controller.current) controller.current.abort();

		controller.current = new AbortController();

		let api_key = getCookie("key");
		await fetch("/_api/skl/list?" + sp.toString(), {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: "API-TOKEN api-key=" + api_key,
			},
			signal: controller.current.signal,
		})
			.then((res) => {
				if (res.status == 200) {
					return res.json();
				}

				if (res.status == 401) {
					window.alert("NOT LOGGED IN");
					window.location.href = "/?rd=" + encodeURI(window.location.href);
				}

				if (res.status == 403) {
					window.alert("FORBIDDEN");
					window.location.href = "/";
				}
			})
			.then((result) => {
				let x;
				if (state.page == 1) {
					x = result.items;
				} else {
					x = items.slice();

					x = x.concat(result.items);
				}

				if (result.items < 100) {
					setMore(false);
				} else {
					setMore(true);
				}

				setPage((x) => x + 1);
				setItems(x);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
			});
	}

	useEffect(() => {
		load();
	}, [state]);

	return (
		<>
			<div
				style={{
					padding: 8,
					display: "flex",
					backgroundColor: "#005e11",
					color: "white",
					fontSize: "200%",
				}}
			>
				<img style={{ width: 48, marginRight: 16 }} src={logo} />

				<div>MADRASAH JATENG</div>
			</div>

			<div style={{ padding: 16 }}>
				<div
					style={{
						margin: "auto",
						marginBottom: 15,
						textAlign: "right",
						display: "flex",
						justifyContent: "space-between",
						alignItems: "baseline",
					}}
				>
					<div>
						<Link to="/asts/asts-admin/import">
							<button
								style={{
									padding: 8,
									color: "white",
									backgroundColor: "green",
									borderRadius: 5,
									border: 0,
								}}
							>
								Import Data
							</button>
						</Link>
					</div>{" "}
					<SearchBox
						style={{ width: 300 }}
						onChange={(v) => {
							dispatch({ type: "query", payload: v });
						}}
					/>
				</div>
				<div style={{ overflowX: "auto" }}>
					<table
						width="100%"
						cellPadding={10}
						cellSpacing={0}
						className="t_daftar"
						style={{ textAlign: "right" }}
					>
						<thead style={{ backgroundColor: "#eee" }}>
							<tr style={{ textAlign: "center" }}>
								<td>No</td>

								<td onClick={() => doSort("nisn")} className="sortable">
									NISN{" "}
									{state.sort == "nisn" &&
										(state.sort_order == 1 ? <>&darr;</> : <>&uarr;</>)}
								</td>

								<td
									onClick={() => doSort("nama")}
									// width="100%"
									className="sortable"
								>
									Nama
									{state.sort == "nama" &&
										(state.sort_order == 1 ? <>&darr;</> : <>&uarr;</>)}
								</td>
								<td>TTL</td>
								<td>JK</td>
								<td onClick={() => doSort("kelas")} className="sortable">
									Kelas{" "}
									{state.sort == "kelas" &&
										(state.sort_order == 1 ? <>&darr;</> : <>&uarr;</>)}
								</td>
								<td onClick={() => doSort("jurusan")} className="sortable">
									Asal Madrasah{" "}
									{state.sort == "jurusan" &&
										(state.sort_order == 1 ? <>&darr;</> : <>&uarr;</>)}
								</td>
								<td onClick={() => doSort("lulus")} className="sortable">
									Keterangan{" "}
									{state.sort == "lulus" &&
										(state.sort_order == 1 ? <>&darr;</> : <>&uarr;</>)}
								</td>
								<td onClick={() => doSort("link")} className="sortable">
									Link{" "}
									{state.sort == "link" &&
										(state.sort_order == 1 ? <>&darr;</> : <>&uarr;</>)}
								</td>
							</tr>
						</thead>
						<tbody>
							{items.map((i, idx) => (
								<tr key={i.nisn}>
									<td style={{ textAlign: "center" }}>{idx + 1}</td>
									<td style={{ textAlign: "center" }}>{i.nisn}</td>
									<td style={{ textAlign: "left" }}>{i.nama}</td>
									<td style={{ textAlign: "center" }}>
										{i.tmp_lahir} <br />
										{i.tgl_lahir}
									</td>
									<td style={{ textAlign: "center" }}>
										{i.jk == 1 ? "L" : "P"}
									</td>
									<td style={{ textAlign: "center" }}>{i.kelas}</td>
									<td style={{ textAlign: "center" }}>{i.jurusan}</td>
									<td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
										{i.lulus == 0 ? (
											<span
												style={{
													color: "white",
													background: "red",
													borderRadius: 4,
													padding: 5,
												}}
											>
												TIDAK LULUS
											</span>
										) : (
											<span
												style={{
													color: "white",
													background: "#3BD144",
													borderRadius: 4,
													padding: 5,
												}}
											>
												LULUS
											</span>
										)}
										{/* <br />{" "}
	<a href={i.link} target="_blank">
	{i.link}
	</a> */}
									</td>
									<td style={{ textAlign: "left" }}>
										<a href={i.link} target="_blank">
											{i.link}
										</a>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div style={{ margin: 10 }}>
					{loading && <span>Loading...</span>}
					{!loading && items.length >= 100 && more && (
						<button
							fullWidth
							onClick={() => {
								dispatch({ type: "more" });
							}}
						>
							Halaman Berikutnya
						</button>
					)}
				</div>
			</div>
		</>
	);
}
